module.exports = __webpack_public_path__ + "img/95ec71ef38870e90656b0727e72c976e.png";